import { LitElement, html, css } from '@hh/global.js'

class HHCollectionBanner extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.btn = this.querySelector('.js-collection-read-more')
    this.content = this.querySelector('.js-collection-more')

    document.addEventListener(
      'toggleCollectionDescription',
      this.toggleCollectionDescription.bind(this)
    )
  }

  toggleCollectionDescription() {
    if (this.content.classList.contains('is-active')) {
      this.content.classList.remove('is-active')
      this.btn.textContent = this.btn.getAttribute('data-show-text')
    } else {
      this.content.classList.add('is-active')
      this.btn.textContent = this.btn.getAttribute('data-hide-text')
    }
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-collection-banner', HHCollectionBanner)
